// Appointment booking and cancellation.

import { ErrorEntry } from './error-metadata.types';

export const appointmentsErrors = {
  'booking-link-already-used': {
    message:
      'This booking link has already been used, so an appointment cannot be booked with it again.',
    title: 'This link has already been used',
    showBackButton: false,
  },
  'booking-link-no-longer-available': {
    message:
      'This booking link is no longer available. Contact your GP practice if you still need an appointment.',
    title: 'This link is no longer available',
    showBackButton: false,
  },
  'patient-does-not-meet-criteria': {
    message:
      'You are not eligible to book this appointment online. Contact your GP practice to discuss your options.',
    title: 'Unable to book this appointment',
  },
  'patient-cannot-proceed': {
    message:
      'It’s not possible to continue with this booking online. Please contact your GP practice.',
    title: 'Unable to proceed',
  },
  // ENG-21800 The literal code BookingLinkChecker emits — a shorter name here
  // would never match the response.
  'patient-cannot-book-more-than-one-appointment-within-12-hours': {
    message:
      'You already have an appointment booked within 12 hours of this one, so another cannot be booked.',
    title: 'You already have an appointment booked',
    showBackButton: false,
  },
  'reason-for-appointment-required': {
    message: 'A reason for the appointment is needed before it can be booked.',
    title: 'Tell us why you need this appointment',
    redirectToError: false,
  },
  'booking-link-not-found': {
    message:
      'We could not find that booking link. Check the link in your message, or contact your GP practice.',
    title: 'Booking link not found',
    showBackButton: false,
  },
  'slot-no-longer-available': {
    message: 'That appointment time has just been taken. Please choose another one.',
    title: 'That time is no longer available',
    redirectToError: false,
  },
  // ENG-21800 Literal strings AppointmentCancellationChecker emits: the controller
  // uses the exception message as `code`, so a friendlier name would never match.
  'appointment-already-cancelled': {
    message: 'This appointment has already been cancelled.',
    title: 'This appointment is already cancelled',
    showBackButton: false,
  },
  'appointment-in-the-past': {
    message: 'This appointment has already taken place, so it can no longer be cancelled.',
    title: 'Unable to cancel this appointment',
    showBackButton: false,
  },
  'appointment-started': {
    message:
      'This appointment has already started, so it can no longer be cancelled online. Please contact your GP practice.',
    title: 'Unable to cancel this appointment',
    showBackButton: false,
  },
  'appointment-rescheduled': {
    message:
      'This appointment has been rescheduled, so this link can no longer be used to cancel it.',
    title: 'This appointment has been rescheduled',
    showBackButton: false,
  },
  'appointment-not-found': {
    message:
      'We could not find that appointment. Check the link in your message, or contact your GP practice.',
    title: 'Appointment not found',
    showBackButton: false,
  },
} satisfies Record<string, ErrorEntry>;
